module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"categories":"Categories","count":"Displaying articles {first}-{last} of {total}","noneMatching":"No matching articles found"}}')
  delete Component.options._Ctor
}
